import { FC, ReactNode, useCallback, useEffect, useMemo, useState, useRef } from 'react';
import AlertContext, { Alert } from './AlertContext';

interface Props {
  children: ReactNode;
}

export const ALERT_TIMEOUT = 6000;

const AlertProvider: FC<Props> = ({ children }) => {
  const [alert, setAlert] = useState<Alert | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const displayAlert = useCallback((newAlert: Alert) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setAlert(newAlert);

    timeoutRef.current = setTimeout(() => {
      setAlert(null);
      timeoutRef.current = null;
    }, ALERT_TIMEOUT);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const value = useMemo(
    () => ({
      alert,
      displayAlert,
    }),
    [alert, displayAlert],
  );

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
